import { Cases } from './../../types';
import { baseApiClient } from '../clients';

const CASES_URL = '/cases';

const getCases = () => baseApiClient.get<Cases>(CASES_URL);

export default getCases;
